<div class="main-content">
    <div *ngIf="isAdmin" class="container-fluid">
        <div class="row"></div>
        <div>
            <div class="ml-5 pl-3 row">
                <p-dropdown [options]="rapports" [(ngModel)]="selectedRapport"
                            (onChange)="generateRapport()"
                            optionLabel="name"></p-dropdown>
            </div>
            <div class="ml-5 mr-3 mt-4 row">
                <div class="col">
                    <div>Année</div>
                    <p-dropdown appendTo="body" [options]="years" [(ngModel)]="selectedYear"
                                (onChange)="generatePeriods()"
                                optionLabel="label" optionValue="value"></p-dropdown>
                </div>
                <div class="col">
                    <div>Fréquence</div>
                    <p-dropdown appendTo="body" (onChange)="generatePeriods()" [options]="frequencyChoice"
                                [(ngModel)]="frequency"
                                optionLabel="label" optionValue="value"></p-dropdown>
                </div>
                <div class="col">
                    <div>Période</div>
                    <p-multiSelect appendTo="body" [options]="choosenPeriode"
                                   [selectionLimit]="maxSelectedWeeksNumber"
                                   selectedItemsLabel="{0} periode choisit"
                                   maxSelectedLabels="2"
                                   [(ngModel)]="selectedPeriod" optionLabel="name"></p-multiSelect>
                </div>
                <div class="col">
                    <div>Age</div>
                    <p-multiSelect appendTo="body" [options]="ageChoice"
                                   [(ngModel)]="ages" optionLabel="label"></p-multiSelect>
                </div>
                <div class="col">
                    <div>Code Postal</div>
                    <p-dropdown [options]="zipCodes" [(ngModel)]="selectedZipCode"
                                optionLabel="label"></p-dropdown>
                </div>
                <div class="col mt-4">
                    <button pButton pRipple label="Générer rapport"
                            class="p-button-success mr-2 njoyButton"
                            (click)="generateRapport()"></button>
                </div>
            </div>

        </div>

        <div *ngIf="selectedRapport.code === 'RSN' || selectedRapport.code === 'RIN'" class="row mt-5 ml-5 pl-3">Total de <span
                class="ml-2 font-weight-bold">{{totalElements}} {{rapportTitle}}</span>
        </div>
        <div class="row mt-3 ml-5 pl-3">Période sélectionnée: <span
                class="ml-2 font-weight-bold">{{periodeSelectedTitle}}</span></div>


        <div class="pl-3 ml-5 mr-5">
            <div *ngIf="!selectedRapport.withFilters && selectedRapport.code !== 'SPCP'"
                 class="container ml-5 mr-5 mt-5">
                <p-table #dt [value]="values" [rows]="10" [paginator]="true"
                         [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]">
                    <ng-template pTemplate="header">
                        <tr>
                            <th *ngIf="selectedRapport.code === 'SPO'">{{ 'RAPPORTS.OFFER_LABEL' | translate }}</th>
                            <th>{{ 'RAPPORTS.PARTNER_NAME_LABEL' | translate }}</th>
                            <th>{{ 'RAPPORTS.SCAN_NUMBER_LABEL' | translate }}</th>
                            <th *ngIf="selectedRapport.code === 'SPO'">{{ 'RAPPORTS.CATEGORY_LABEL' | translate }}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-elementScanned>
                        <tr>
                            <td *ngIf="selectedRapport.code === 'SPO'">{{elementScanned.offerLabel}}</td>
                            <td>{{elementScanned.partnerName}}</td>
                            <td>{{elementScanned.scanNumber}}</td>
                            <td *ngIf="selectedRapport.code === 'SPO'">{{elementScanned.categoryName}}</td>

                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div *ngIf="selectedRapport.code === 'SPCP'">
                <div class="col-md-12">
                    <div class="card card-chart">
                        <div class="chart-wrapper">
                            <p-chart #scanPerCategoryChart type="doughnut" [data]="scanPerCategoryPieData"
                                     [options]="chartOptions"
                                     [style]="{'width': '40%'}"></p-chart>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="selectedRapport.code === 'RSVIN'">
                <div class="col-md-12">
                    <div class="card card-chart">
                        <h4 class="card-title text-center">Evolution abonnés/inscrits par période</h4>
                        <div class="chart-wrapper">
                            <p-chart #RSVINLineChart type="line" [data]="rsvinData" [options]="rsvinOptions"></p-chart>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="selectedRapport.code === 'RSN' || selectedRapport.code === 'RIN'" class="row">
                <div class="col-md-6">
                    <div class="card card-chart">
                        <h4 class="card-title text-center">Evolution par période</h4>
                        <div class="chart-wrapper">
                            <p-chart #usersPerSexAndDateChart type="bar" [data]="stackedData"
                                     [options]="stackedOptions"></p-chart>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card card-chart">
                        <h4 class="card-title text-center">Répartition par sexe</h4>
                        <div class="chart-wrapper">
                            <p-chart #usersPerSexPieChart type="doughnut" [data]="usersPerSexPieData"
                                     [options]="usersPerSexPieOptions"
                                     [style]="{'width': '40%'}"></p-chart>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="selectedRapport.code === 'RPN'" class="row">
                <div class="col-md-12">
                    <div class="card card-chart">
                        <div class="chart-wrapper">
                            <p-chart #partnersChart type="bar" [data]="partnerChartData"
                                     [options]="chartOptions"></p-chart>
                        </div>
                        <div class="card-body">
                            <h4 class="card-title">Nombre total des partenaires {{totalPartnerNumber}}</h4>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="selectedRapport.code === 'TS'">
                <div class="row">
                    <div class="col-4">
                        <div class="card card-chart">
                            <h4 class="card-title text-center">Evolution par période</h4>
                            <div class="chart-wrapper">
                                <p-chart #scanPerSexAndDateChart type="bar" [data]="stackedData"
                                         [options]="stackedOptions"></p-chart>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="card card-chart">
                            <h4 class="card-title text-center">Répartition par âge</h4>
                            <div class="chart-wrapper">
                                <p-chart #scanPerSexPieChart type="doughnut" [data]="scanPerAgePieData"
                                         [options]="usersPerSexPieOptions"
                                         [style]="{'width': '40%'}"></p-chart>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="card card-chart">
                            <h4 class="card-title text-center">Répartition par département</h4>
                            <div class="chart-wrapper">
                                <p-chart #scanPerDepartmentPieChart type="doughnut" [data]="scanPerDepartmentPieData"
                                         [options]="scanPerDepartmentPieOptions"
                                         [style]="{'width': '40%'}"></p-chart>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="row">
                     <div class="col-6">
                     </div>
                     <div class="col-6">
                         <div class="card card-chart">
                             <div class="chart-wrapper">
                                 <p-chart #scanPerOfferPieChart type="doughnut" [data]="scanPerOfferPieData"
                                          [options]="usersPerSexPieOptions"
                                          [style]="{'width': '40%'}"></p-chart>
                             </div>
                         </div>
                     </div>
                 </div>-->
            </div>

            <div *ngIf="selectedRapport.code === 'RCA'" class="row">
                <div class="col-md-6">
                    <div class="card card-chart">
                        <div class="chart-wrapper">
                            <p-chart #caPerDateChart type="bar" [data]="stackedData"
                                     [options]="stackedOptions"></p-chart>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card card-chart">
                        <div class="chart-wrapper">
                            <p-chart #billingTypePieChart type="doughnut" [data]="billingTypePieData"
                                     [options]="usersPerSexPieOptions"
                                     [style]="{'width': '40%'}"></p-chart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!isAdmin" class="container-fluid">
        <div class="row"></div>
        <div class="row"></div>
        <div class="row">
            <div class="col-md-4">
                <div class="card card-chart">
                    <div class="card-header card-header-warning">
                        <div class="ct-chart" id="websiteViewsChart"></div>
                    </div>
                    <div class="card-body">
                        <h4 class="card-title">Nombre de scan</h4>
                        <p class="card-category"><span class="text-success"><i
                                class="fa fa-long-arrow-up"></i> 55% </span> de plus des scan.</p>
                    </div>
                    <div class="card-footer">
                        <div class="stats">
                            <i class="material-icons">access_time</i> mise à jour aujourd'hui
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card card-chart">
                    <div class="card-header card-header-success">
                        <div class="ct-chart" id="dailySalesChart"></div>
                    </div>
                    <div class="card-body">
                        <h4 class="card-title">Gain</h4>
                        <p class="card-category">
                            Variation du gain par jour
                        </p>
                    </div>
                    <div class="card-footer">
                        <div class="stats">
                            <i class="material-icons">access_time</i> mise à jour il y a 4 minutes
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card card-chart">
                    <div class="card-header card-header-success">
                        <div class="ct-chart" id="completedTasksChart"></div>
                    </div>
                    <div class="card-body">
                        <h4 class="card-title">Nombre des commandes</h4>
                        <p class="card-category">
                            Variation du commandes par mois
                        </p>
                    </div>
                    <div class="card-footer">
                        <div class="stats">
                            <i class="material-icons">access_time</i> mise à jour aujourd'hui
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
        <div class="row"></div>
    </div>

</div>
